export const GET_CAROUSEL_FOOTER_ITEMS = 'GET_CAROUSEL_FOOTER_ITEMS';
